module.exports = __webpack_public_path__ + "img/dynamic-31.8c14e51c.png";